var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconFoodDeliveryFoodBillHistoryTicket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8.636,
    cy: 9.5,
    rx: 2.25,
    ry: 2.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.636 12.125v4m6.5-4v4m-1.5-9.25v3.75a1.5 1.5 0 0 0 1.5 1.5h0a1.5 1.5 0 0 0 1.5-1.5v-3.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.01 23.25a3.485 3.485 0 0 1 6.021 0V.75a3.5 3.5 0 0 1-3.01 1.73A3.5 3.5 0 0 1 15.01.75 3.5 3.5 0 0 1 12 2.48 3.5 3.5 0 0 1 8.99.75a3.5 3.5 0 0 1-3.011 1.73A3.5 3.5 0 0 1 2.969.75v22.5a3.485 3.485 0 0 1 6.021 0 3.484 3.484 0 0 1 6.02 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconFoodDeliveryFoodBillHistoryTicket);
export default __webpack_public_path__ + "static/media/streamline-icon-food-delivery-food-bill-history-ticket.3f7c9d5b.svg";
export { ForwardRef as ReactComponent };